export default __webpack_public_path__ + "static/media/trains.75dc6ecc.svg";